import React, { useState } from 'react';
import { PenLine } from 'lucide-react';
import { SignaturePad } from './SignaturePad';
import { RutField } from '../RutField';

const rutOk = (rut) => {
  const r = (rut || '').replace(/[^0-9kK]/g, '').toUpperCase();
  if (r.length < 8 || r.length > 9) return false;
  let s = 0; let f = 2;
  for (const ch of r.slice(0, -1).split('').reverse()) { s += Number(ch) * f; f = f === 7 ? 2 : f + 1; }
  const e = 11 - (s % 11);
  return r.slice(-1) === (e === 11 ? '0' : e === 10 ? 'K' : String(e));
};

// Approve with simple electronic signature: full name + valid RUT + drawn signature + declaration
export const SignApproveForm = ({ busy, onSign, onBack }) => {
  const [name, setName] = useState('');
  const [rut, setRut] = useState('');
  const [sig, setSig] = useState(null);
  const [ok, setOk] = useState(false);
  const rutValid = rutOk(rut);
  const ready = name.trim().split(/\s+/).length >= 2 && rutValid && sig && ok;
  return (
    <div data-testid="approval-sign-form" className="space-y-3">
      <p className="flex items-center gap-2 text-sm font-semibold"><PenLine className="h-4 w-4" />Firma electrónica simple</p>
      <input data-testid="approval-signer-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Nombre completo" className="w-full rounded-xl border border-slate-300 p-3 text-sm" />
      <RutField testid="approval-signer-rut" value={rut} onChange={setRut} placeholder="RUT (ej. 12.345.678-5)" className={`w-full rounded-xl border p-3 text-sm ${rut && !rutValid ? 'border-red-400' : 'border-slate-300'}`} />
      {rut && !rutValid && <p data-testid="approval-rut-error" className="text-xs text-red-600">RUT no válido</p>}
      <SignaturePad onChange={setSig} />
      <label className="flex items-start gap-2 text-xs text-slate-600">
        <input data-testid="approval-accept" type="checkbox" checked={ok} onChange={(e) => setOk(e.target.checked)} className="mt-0.5" />
        Declaro que leí el escrito y lo apruebo para su presentación, firmándolo con firma electrónica simple (Ley 19.799).
      </label>
      <button data-testid="approval-sign-btn" disabled={busy || !ready} onClick={() => onSign({ signer_name: name, signer_rut: rut, signature: sig, accepted: ok })}
        className="w-full rounded-xl bg-emerald-600 py-3 font-semibold text-white disabled:opacity-50">Firmar y aprobar escrito</button>
      <button onClick={onBack} className="w-full text-xs text-slate-500">Volver</button>
    </div>
  );
};
